// extracted by mini-css-extract-plugin
export var quantityInput = "_fa-0";